import type { ICellRendererParams } from 'ag-grid-enterprise';
import { IconButton } from '../Button';
import type { AgGridIconButtonProps } from './types';

export function AgGridIconButton({
  hide,
  onClick,
  icon,
  node,
  api,
  disabled,
  color,
  title,
  data,
  dataValue,
}: ICellRendererParams & AgGridIconButtonProps) {
  if (!data || node.rowPinned) {
    return null;
  }

  if (hide?.({ node, api })) {
    return null;
  }

  return (
    <IconButton
      data-value={dataValue}
      ghost={true}
      icon={icon}
      disabled={disabled}
      // Adding an onClick directly to this Button triggers the onSelectionChanged event of the AgGrid
      ref={ref => {
        if (ref != null) {
          ref.onclick = e => {
            e.stopPropagation();
            onClick?.({ node, api });
          };
        }
      }}
      color={color}
      title={title}
      data-testid="ag-grid-icon-button"
    />
  );
}
